import React from 'react'
import { Card, Drawer, Fade } from '@mui/material'
import { Close } from '@mui/icons-material'
import Suspense from 'components/Suspense'
import SuspensePlaceholder from 'components/SuspensePlaceholder'
import Box from 'components/Box'
import Button from 'components/Button'
import { classList, StandardWidth } from 'services/styles'
import { usePageState } from 'hooks/usePageState'
import useStyles from './styles'

export interface IPageSidebarProps {
  sticky?: boolean
  style?: React.CSSProperties
  children: React.ReactNode
  requiredScreenWidth?: StandardWidth
}

// TODO: use a hook for this so it pulls from the theme spacing
export const PAGE_SIDEBAR_WIDTH = 288

function PageSidebar(props: IPageSidebarProps) {
  const { classes } = useStyles()
  const { children, sticky, style, requiredScreenWidth = 'lg', ...restProps } = props

  const {
    pageSidebarHidden,
    pageSidebarOpen,
    setPageSidebarOpen,
    setRequiredSidebarWidth,
    incrementPageSidebarCount,
    decrementPageSidebarCount,
  } = usePageState()

  React.useEffect(() => {
    setRequiredSidebarWidth(requiredScreenWidth)
  }, [requiredScreenWidth, setRequiredSidebarWidth])

  React.useEffect(() => {
    incrementPageSidebarCount()
    return () => decrementPageSidebarCount()
  }, [incrementPageSidebarCount, decrementPageSidebarCount])

  if (pageSidebarHidden) {
    return (
      <Drawer open={pageSidebarOpen} onClose={() => setPageSidebarOpen(false)}>
        <Suspense fallback={<div />} ErrorFallbackComponent={errorProps => <SuspensePlaceholder {...errorProps} raised={false} flat />}>
          <div style={{ maxWidth: PAGE_SIDEBAR_WIDTH }}>
            {children}
          </div>
        </Suspense>

        <Box style={{ marginTop: 'auto', textAlign: 'right' }}>
          <Button onClick={() => setPageSidebarOpen(false)} color="secondary" startIcon={<Close />}>
            Close
          </Button>
        </Box>
      </Drawer>
    )
  }

  return (
    <div className={classes.wrapper} style={style}>
      <div className={classes.container} style={{ width: PAGE_SIDEBAR_WIDTH }} {...restProps}>
        <div className={classList(classes.content, sticky ? classes.sticky : undefined)}>
          <div>
            <Box disableRightPadding>
              <Card>
                <Suspense fallback={<div />} ErrorFallbackComponent={errorProps => <SuspensePlaceholder {...errorProps} raised={false} flat />}>
                  <Fade appear in>
                    <div>
                      {children}
                    </div>
                  </Fade>
                </Suspense>
              </Card>
            </Box>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(PageSidebar)
